import deepGet from "./_deepGet.js";
import toPath from "./_toPath.js";
export default function property(path) {
  path = toPath(path);
  return function(obj) {
    return deepGet(obj, path);
  };
}
